import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-diploma-supplement-value-block',
    templateUrl: './value-block.component.html'
})
export class DiplomaSupplementValueBlockComponent {
    @Input() item: { index: string, title: string };
    @Input() translate: (key: string, language: 'lv' | 'en') => string;
}
